<div *ngIf="student" class="student-profile-page">
  <div class="container student-profile-shell">
    <section class="student-profile-hero">
      <div class="student-profile-identity">
        <div class="student-profile-badges">
          <span class="student-chip">Dossier élève</span>
          <span class="student-chip student-chip--status">{{ studentStatusValue }}</span>
          <span class="student-chip student-chip--danger" *ngIf="isArchived">Archivé</span>
        </div>

        <h1>{{ student.lastname }} {{ student.firstname }}</h1>
      </div>

      <div class="student-profile-side">
        <div class="student-profile-meta">
          <span class="student-meta-pill"><i class="fa fa-phone"></i> {{ student.phoneNumber | removewhitespaces }}</span>
          <span class="student-meta-pill" *ngIf="student.email"><i class="fa fa-envelope-o"></i> {{ student.email }}</span>
          <span class="student-meta-pill" *ngIf="student.registrationDate"><i class="fa fa-calendar"></i> Inscrit le {{ student.registrationDate | date:'dd/MM/yyyy' }}</span>
        </div>

        <div class="student-profile-actions">
          <button type="button" class="btn btn-primary" (click)="onShowDrivingBook()">
            <i class="fa fa-road"></i> Suivi drive
          </button>
          <button type="button" class="btn btn-outline-primary" (click)="onShowDetails()" *ngIf="(isAdmin() || readOnlyService.isReader()) && !isOwnProfile()">
            <i class="fa fa-pencil-square-o"></i> Détails
          </button>
          <button type="button" class="btn btn-outline-primary" (click)="onOpenUserForm()" *ngIf="!readOnlyService.isReadOnly()">
            <i class="fa fa-lock"></i> Mot de passe
          </button>
        </div>
      </div>
    </section>

    <div *ngIf="student">
      <app-note [iFolderStatus]="getFolderStatus(student.folderStatus)" (oFolderStatus)="updateFolderStatus($event)"></app-note>
    </div>

    <div class="alert alert-danger alert-dismissible fade show student-alert" role="alert" *ngIf="messageError.length > 0">
      <strong>Erreur :</strong> {{ messageError }}.
      <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="deleteMessageError()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <section class="student-profile-toolbar">
      <div class="student-profile-toolbar-copy">
        <div class="student-profile-toolbar-mainline">
          <span class="student-toolbar-label">Gestion du dossier</span>
          <strong class="student-formula-pill">
            <i class="fa fa-id-card-o"></i> {{ student.formula.name }}
          </strong>
        </div>
        <span class="student-profile-toolbar-description" *ngIf="student.formula.description">{{ student.formula.description }}</span>
      </div>

      <div class="student-toolbar-balance"
           [ngClass]="toPay > 0 ? 'student-toolbar-balance--warning' : 'student-toolbar-balance--success'">
        <span class="student-balance-label">{{ toPay > 0 ? 'Montant restant à payer' : 'Paiement à jour' }}</span>
        <strong>{{ toPay > 0 ? (toPay | number: '1.2-2') : ('+' + (-toPay | number: '1.2-2')) }} €</strong>
      </div>

      <div class="student-profile-toolbar-actions">
        <div class="btn-group" *ngIf="isAdmin()">
          <button type="button" [ngClass]="btnValideStatusActive ? 'btn btn-primary' : 'btn btn-outline-primary'"
                  (click)="valideNewStudentStatus()" [disabled]="!btnValideStatusActive">
            Statut : {{ studentStatusValue }}
          </button>
          <button type="button" class="btn btn-outline-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="sr-only">Modifier le statut</span>
          </button>
          <div class="dropdown-menu dropdown-menu-right">
            <a class="dropdown-item" (click)="initNewStudentStatus('TO_CREATE')">A créer</a>
            <a class="dropdown-item" (click)="initNewStudentStatus('IN_PROGRESS')">En cours</a>
            <a class="dropdown-item" (click)="initNewStudentStatus('PERMIS_VALIDATED')">A eu le permis</a>
            <a class="dropdown-item" (click)="initNewStudentStatus('FINISH')">A quitter</a>
            <a class="dropdown-item" (click)="initNewStudentStatus('CANCEL')">Annuler</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" (click)="initNewStudentStatus('CANCEL_UPDATE')">Annuler la modification</a>
          </div>
        </div>

        <button type="button" class="btn btn-outline-danger" (click)="removeStudent()" *ngIf="isSuperAdmin() && !isMobilePhone()">
          <i class="fa fa-trash-o"></i> Supprimer
        </button>
      </div>
    </section>

    <section class="student-summary-grid">
      <article class="student-summary-card student-summary-card--hours"
               [ngClass]="{
                 'student-summary-card--active': showDrivingEvents,
                 'student-summary-card--alert': hasHoursOverrun
               }"
               role="button"
               tabindex="0"
               [attr.aria-pressed]="showDrivingEvents"
               (click)="selectPanel('hours')"
               (keydown.enter)="selectPanel('hours')"
               (keydown.space)="selectPanel('hours')">
        <div class="student-summary-head">
          <span class="student-summary-icon"><i class="fa fa-road"></i></span>
          <span class="student-summary-label">Heures de conduite</span>
        </div>
        <strong class="student-summary-value" [ngClass]="{ 'student-summary-value--alert': hasHoursOverrun }">
          {{ totalDrivingEventsOfStudent }} / {{ numberHoursPurchased }}
          <small>heures</small>
        </strong>
        <span class="student-summary-alert" *ngIf="hasHoursOverrun">
          <i class="fa fa-exclamation-triangle"></i>
          Dépassement de {{ hoursOverrun }} h par rapport aux heures ajoutées
        </span>
        <span class="student-summary-note">
          Consommées {{ numberHoursConsumed }} h · Réservées {{ numberHoursReserved }} h
        </span>
      </article>

      <article class="student-summary-card student-summary-card--payments"
               [ngClass]="{ 'student-summary-card--active': showPayments }"
               role="button"
               tabindex="0"
               [attr.aria-pressed]="showPayments"
               (click)="selectPanel('payments')"
               (keydown.enter)="selectPanel('payments')"
               (keydown.space)="selectPanel('payments')">
        <div class="student-summary-head">
          <span class="student-summary-icon"><i class="fa fa-credit-card"></i></span>
          <span class="student-summary-label">Paiements</span>
        </div>
        <strong class="student-summary-value">
          {{ totalPayments }}
          <small>euros</small>
        </strong>
        <span class="student-summary-note">Encaissements et remboursements liés au dossier.</span>
      </article>

      <article class="student-summary-card student-summary-card--consumptions"
               [ngClass]="{ 'student-summary-card--active': showConsumptions }"
               role="button"
               tabindex="0"
               [attr.aria-pressed]="showConsumptions"
               (click)="selectPanel('consumptions')"
               (keydown.enter)="selectPanel('consumptions')"
               (keydown.space)="selectPanel('consumptions')">
        <div class="student-summary-head">
          <span class="student-summary-icon"><i class="fa fa-file-text-o"></i></span>
          <span class="student-summary-label">Consommations</span>
        </div>
        <strong class="student-summary-value">
          {{ totalConsumptions }}
          <small>euros</small>
        </strong>
        <span class="student-summary-note">Prestations et montants consommés sur le compte élève.</span>
      </article>
    </section>

    <section class="student-detail-panel">
      <div class="student-detail-panel-head">
        <div>
          <span class="student-toolbar-label">Vue active</span>
          <h2>{{ activePanelTitle }}</h2>
        </div>

        <div class="student-detail-panel-actions">
          <ng-container *ngIf="showDrivingEvents">
            <button type="button" class="btn btn-primary" (click)="openCalendar()">
              <i class="fa fa-calendar"></i> Ouvrir le planning
            </button>
          </ng-container>

          <ng-container *ngIf="showPayments && isAdmin()">
            <button type="button" class="btn btn-outline-primary" (click)="onOpenRefundForm()" [disabled]="isArchived">
              <i class="fa fa-undo"></i> Remboursement
            </button>
            <button type="button" class="btn btn-primary" (click)="onOpenPaymentForm()" [disabled]="isArchived">
              <i class="fa fa-plus"></i> Ajouter paiement
            </button>
          </ng-container>

          <ng-container *ngIf="showConsumptions && isAdmin()">
            <button type="button" class="btn btn-primary" (click)="onOpenConsumptionForm()" [disabled]="isArchived">
              <i class="fa fa-plus"></i> Ajouter consommation
            </button>
          </ng-container>
        </div>
      </div>

      <app-payment-list [iShowPayments]="showPayments" [iPayments]="payments" [iPagePayment]="pagePayment"
                        [iShowInvoiceNumber]="true"
                        [iShowUpdateBtn]="isAdmin()"
                        [iShowRefundButton]="false"
                        [iIsStudent]="!isAdmin()"
                        (iPageNumber)="onChangePaymentPage($event)"
                        (oPaymentToUpdate)="initPaymenToUpdate($event)"
                        (oPaymentDisabled)="disabledPayment($event)"
                        (oOpenRefundForm)="onOpenRefundForm()">
      </app-payment-list>

      <app-consumption-list [iShowConsumptions]="showConsumptions" [iConsumptions]="consumptions"
                            [iPageConsumption]="pageConsumption" [iNavMobile]="navMobile" [iIsOneStudent]="true"
                            [iIsStudent]="!isAdmin()" [iShowUpdateBtn]="isAdmin()"
                            (iPageNumber)="onChangeConsumptionPage($event)" (oConsumptionToUpdate)="initConsumptionToUpdate($event)">
      </app-consumption-list>

      <app-driving-event-list [iShowDrivingEvents]="showDrivingEvents" [iDrivingEvents]="drivingEvents"
                              [iPageDrivingEvent]="pageDrivingEvent" [iNavMobile]="!navMobile"
                              (iPageNumber)="onChangeDrivingEventPage($event)">
      </app-driving-event-list>
    </section>

    <app-payment-form *ngIf="!navMobile && isAdmin()" (oNewPayment)="onRefreshPayment($event)" [iStudent]="student"
                      [iPaymentMethods]="paymentMethods" [isRefund]="isRefundMode"></app-payment-form>

    <app-payment-update-form *ngIf="!navMobile && isAdmin()" (oPaymentUpdated)="onRefreshPayment($event)" [iPayment]="paymentToUpdate"
                             [iStudent]="student" [iPaymentMethods]="paymentMethods"></app-payment-update-form>

    <app-consumption-form *ngIf="!navMobile && isAdmin()" (oNewConsumption)="onAddConsumption($event)"
                          [iStudent]="student" [iArticles]="articles"></app-consumption-form>

    <app-consumption-update-form *ngIf="!navMobile && isAdmin()" (oUpdateConsumption)="onRefreshConsumptions($event)"
                                 [iStudent]="student" [iArticles]="articles"
                                 [iConsumption]="consumptionToUpdate">
    </app-consumption-update-form>

    <app-user-update-pwd *ngIf="student" [iStudent]="student"></app-user-update-pwd>
  </div>
</div>
